module.exports = __webpack_public_path__ + "img/pic_hedge.2fc19b3d.png";